import { sourceKindLabel, type AssistSource } from "./assistSources";

export default function AssistSourceList({ sources }: { sources: AssistSource[] }) {
    if (sources.length === 0) {
        return null;
    }
    return (
        <div className="msg-sources" data-testid="assist-sources">
            <p className="msg-sources-heading">Sources</p>
            <ul className="msg-sources-list">
                {sources.map((source) => {
                    const kind = sourceKindLabel(source.kind);
                    const key = `${source.kind}-${source.title}-${source.url ?? ""}`;
                    return (
                        <li key={key} className="msg-sources-item">
                            <span className="msg-sources-kind">{kind}</span>
                            {source.url ? (
                                <a
                                    href={source.url}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="msg-sources-link"
                                >
                                    {source.title}
                                </a>
                            ) : (
                                <span className="msg-sources-title">{source.title}</span>
                            )}
                        </li>
                    );
                })}
            </ul>
        </div>
    );
}
